module.exports = __webpack_public_path__ + "img/logo__new——vi.98f800a2.png";